import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { IconComponent, MessageComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-info-field',
  templateUrl: './evaluation-info-field.component.html',
  styleUrls: ['./evaluation-info-field.component.less'],
  imports: [IconComponent, MessageComponent],
})
export class EvaluationInfoFieldComponent {
  private readonly sanitizer = inject(DomSanitizer);

  protected readonly safeDescription = computed(() =>
    // eslint-disable-next-line ban/ban
    this.sanitizer.bypassSecurityTrustHtml(this.description()),
  );

  public readonly title = input<string>('');
  public readonly description = input<string>('');
}
